export const UnCheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		data-testid="uncheck-circle-icon"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 10C0 4.48578 4.48578 0 10 0C15.5142 0 20 4.48578 20 10C20 15.5142 15.5142 20 10 20C4.48578 20 0 15.5142 0 10ZM13.6827 13.6826C14.0085 13.3566 14.0085 12.8301 13.6827 12.5041L11.1784 10L13.6827 7.49589C14.0085 7.16996 14.0085 6.64338 13.6827 6.31745C13.3568 5.99168 12.8302 5.99168 12.5042 6.31745L10.0001 8.82172L7.49601 6.31745C7.17008 5.99168 6.6435 5.99168 6.31757 6.31745C5.9918 6.64338 5.9918 7.16996 6.31757 7.49589L8.82185 10L6.31757 12.5041C5.9918 12.8301 5.9918 13.3566 6.31757 13.6826C6.48008 13.8451 6.6934 13.9267 6.90687 13.9267C7.12019 13.9267 7.3335 13.8451 7.49601 13.6826L10.0001 11.1783L12.5042 13.6826C12.6668 13.8451 12.8801 13.9267 13.0934 13.9267C13.3069 13.9267 13.5202 13.8451 13.6827 13.6826Z"
			fill="currentColor"
		/>
	</svg>
);
